import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsappButton = () => {
  const number = "918978465525";
  const message = "Hello, I’d like to know more about your services!";
  const whatsappLink = `https://wa.me/${number}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <div>
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          backgroundColor: "#25D366",
          color: "white",
          borderRadius: "50%",
          padding: "15px",
          zIndex: 1000,
          boxShadow: "0 2px 5px rgba(0,0,0,0.3)",
          textDecoration: "none",
        }}
      >
        <FaWhatsapp size={28} />
      </a>
    </div>
  );
};

export default WhatsappButton;
